import { IResponseNewClass } from "./AddNewClass.types"

export const grades = [
  "K",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
]

const GENERAL_TAB_FIELDS: (keyof IResponseNewClass)[] = [
  "name",
  "grade",
  "icon",
  "paycheck_automatic",
  "paycheck_interval",
  "expense_automatic",
  "expense_interval",
  "savings_account_option",
  "interest_option",
  "interest_granting_interval",
  "saving_interest_rate",
  "round_interest_to_whole_number",
]

// Inputs store numbers as strings, so "5" and 5 count as the same value
const isSameValue = (a: unknown, b: unknown) =>
  String(a ?? "") === String(b ?? "")

export const hasUnsavedGeneralChanges = (
  state: IResponseNewClass,
  saved: IResponseNewClass,
) =>
  GENERAL_TAB_FIELDS.some((field) => !isSameValue(state[field], saved[field]))

export const hasUnsavedAttendanceChanges = (
  state: IResponseNewClass,
  saved: IResponseNewClass,
) => !isSameValue(state.attendance_bonus_amount, saved.attendance_bonus_amount)
